/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Reorder a transition's configured actions. Same contract as RuleReorderSerializer.
 * @export
 * @interface ActionReorderRequest
 */
export interface ActionReorderRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionReorderRequest
     */
    transition: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActionReorderRequest
     */
    actionIds: Array<string>;
}

/**
 * Check if a given object implements the ActionReorderRequest interface.
 */
export function instanceOfActionReorderRequest(value: object): value is ActionReorderRequest {
    if (!('transition' in value) || value['transition'] === undefined) return false;
    if ((!('actionIds' in (value as Record<string, any>)) && !('action_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['actionIds'] === undefined && (value as Record<string, any>)['action_ids'] === undefined)) return false;
    return true;
}

export function ActionReorderRequestFromJSON(json: any): ActionReorderRequest {
    return ActionReorderRequestFromJSONTyped(json, false);
}

export function ActionReorderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionReorderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'transition': json['transition'],
        'actionIds': json['action_ids'],
    };
}

export function ActionReorderRequestToJSON(json: any): ActionReorderRequest {
    return ActionReorderRequestToJSONTyped(json, false);
}

export function ActionReorderRequestToJSONTyped(value?: ActionReorderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transition': value['transition'],
        'action_ids': value['actionIds'],
    };
}

